import gsap from "gsap";

export interface ParllaxProps {
  backgroundImage: string;
  middleImage: string;
  foregroundImage: string;
}

export class Parallax {
  private containerEl:HTMLDivElement|null;
  private foregroundEl:HTMLDivElement|null;
  private backgroundEl:HTMLDivElement|null;
  private titleEl:HTMLDivElement|null;
  private ticketsEl:HTMLDivElement|null;

  constructor(element:HTMLDivElement) {
    console.log("parallax constructor", element);
    this.containerEl = null;
    this.foregroundEl = null;
    this.backgroundEl = null;
    this.titleEl = null;
    this.ticketsEl = null;

    if( element !== null && element !== undefined ) {
      this.containerEl = element;

      this.backgroundEl = this.containerEl.querySelector(".movie-slide__parallax-layer.background");
      this.foregroundEl = this.containerEl.querySelector(".movie-slide__parallax-layer.foreground");
      this.titleEl = this.containerEl.querySelector(".movie-slide__parallax-layer.title");
      this.ticketsEl = this.containerEl.querySelector(".movie-slide__parallax-layer.tickets");

      this.initListener();
    }


  }

  private handleMouseMove(e:MouseEvent) {
    // console.log(this);
    // console.log("this.containerEl", this.containerEl);
    if( this.containerEl === null ) {
      return;
    }

    const rect = this.containerEl.getBoundingClientRect();
    const w = rect.width;
    const h = rect.height;

    // Get mouse position relative to container
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const offsetX = 0.5 - x / w;
    const offsetY = 0.5 - y / h;
    const dy = y - h / 2;
    const dx = x - w / 2;
    const theta = Math.atan2(dy, dx);
    let angle = theta * 180 / Math.PI - 90;

    if( angle < 0 ) {
      angle = angle + 360;
    }

    // Poster 3D transform with GSAP
    if( this.backgroundEl ) {
      const offsetPoster = 5;
      gsap.to(
        this.backgroundEl,
        {
          rotateX: -offsetY * offsetPoster,
          rotateY: offsetX * (offsetPoster * 2),
          y: -offsetX * offsetPoster,
          duration: 0.3,
          ease: "power2.out",
          transformPerspective: 800
        }
      )
    }
    
    // Layer parallax with GSAP
    if( this.foregroundEl ) {
      gsap.to(
        this.foregroundEl, 
        {
          x: (offsetX * 4),
          y: (offsetY * 4),
          duration: 0.3,
          ease: "power2.out"
        }
      );
    }

    if( this.titleEl ) {
      gsap.to(
        this.titleEl,
        {
          x: (offsetX * 8),
          y: (offsetY * 8),
          duration: 0.3,
          ease: "power2.out"
        }
      )
    }

    if( this.ticketsEl ) {
      gsap.to(
        this.ticketsEl,
        {
          x: (offsetX * 12),
          y: (offsetY * 12),
          duration: 0.3,
          ease: "power2.out"
        }
      )
    }
  }

  // Reset the poster when mouse leaves the container
  private handleMouseLeave(e:MouseEvent) {
    if( this.backgroundEl ) {
      // const offsetPoster = 5;
      gsap.to(
        this.backgroundEl,
        {
          rotateX: 0,
          rotateY: 0,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
          transformPerspective: 800
        }
      )
    }

    if( this.foregroundEl ) {
      gsap.to(
        this.foregroundEl, 
        {
          x: 0,
          y: 0,
          duration: 0.5,
          ease: "power2.out"
        }
      );
    }

    if( this.titleEl ) {
      gsap.to(
        this.titleEl,
        {
          x: 0,
          y: 0,
          duration: 0.5,
          ease: "power2.out"
        }
      )
    }

    if( this.ticketsEl ) {
      gsap.to(
        this.ticketsEl,
        {
          x: 0,
          y: 0,
          duration: 0.5,
          ease: "power2.out"
        }
      )
    }
  }

  // initListener
  private initListener() {
    if( this.containerEl ) {
      this.containerEl.addEventListener("mousemove", (e:MouseEvent) => { this.handleMouseMove(e); });
      this.containerEl.addEventListener("mouseleave", (e:MouseEvent) => { this.handleMouseLeave(e); });
    }
  }

  private removeListener() {

  }
}